import { commonFilter } from './filter';

export const UgcCreativeTrendsPoint = {
  pageName: 'UGC Creative Trends',
  pageId: '25113',
  pagePath: '/marketing/UgcCreativeTrends',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    status_tab_change: {
      buttonId: '2511301',
    },
    view_switch: {
      buttonId: '2511302',
    },
    search: {
      buttonId: '2511303',
    },
    sort_change: {
      buttonId: '2511304',
    },
    card_click: {
      buttonId: '2511305',
    },
    row_click: {
      buttonId: '2511306',
    },
    drawer_view_all: {
      buttonId: '2511307',
    },
    drawer_title_click: {
      buttonId: '2511308',
    },
    ...commonFilter,
  },
  card: {},
  table: {},
};

export const UgcCreativeTrendsDetailsPoint = {
  pageName: 'UGC Creative Trends Details',
  pageId: '25114',
  pagePath: '/marketing/UgcCreativeTrends/Details',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    view_switch: {
      buttonId: '2511401',
    },
    search: {
      buttonId: '2511402',
    },
    sort_change: {
      buttonId: '2511403',
    },
    ...commonFilter,
  },
  card: {},
  table: {},
};
